export const getDefaultInvoicePostingPeriod = () => {
  const currentYear = new Date().getUTCFullYear();
  const currentMonth = new Date().getUTCMonth() + 1;
  const month = String(currentMonth).padStart(2, '0');

  return `${currentYear}-${month}`;
};
